module.exports = __webpack_public_path__ + "js/6-c8d0e3f8cd88e8646a31.chunk.worker.js"